import fetch, { fetchJson } from 'utils/fetch';

export const displayCreate = () =>
  fetch('/pco-manager/customers/new.json').then(res => res.text());

export const getById = customerId =>
  fetchJson(`/pco-manager/customers/${customerId}/customer.json`);



// WEBPACK FOOTER //
// ./src/modules/saas/customers/api/index.js